// extracted by mini-css-extract-plugin
module.exports = {"prefix":"styles_prefix__Ce1Dw","postfix":"styles_postfix__j5cwv"};